import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate, useParams } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import RoomPage from "@/pages/RoomPage";
import AdminPage from "@/pages/AdminPage";
import StaysPage from "@/pages/StaysPage";
import PoliciesPage from "@/pages/PoliciesPage";
import SurveyPage from "@/pages/SurveyPage";

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => {
                const el = document.querySelector(hash);
                if (el) {
                    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -84, duration: 1.2 });
                    else el.scrollIntoView({ behavior: "smooth" });
                }
            }, 250);
            return () => clearTimeout(t);
        }
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

const LegacyRoomRedirect = () => {
    const { slug } = useParams();
    return <Navigate to={`/alojamientos/${slug}`} replace />;
};

const SmoothScroll = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (pathname.startsWith("/admin")) return undefined;
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, [pathname]);
    return null;
};

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <ScrollManager />
                <SmoothScroll />
            <div className="min-h-screen bg-cream text-ink">
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/alojamientos" element={<StaysPage />} />
                        <Route path="/alojamientos/:slug" element={<RoomPage />} />
                        <Route path="/habitaciones/:slug" element={<LegacyRoomRedirect />} />
                        <Route path="/politicas-de-reservacion-cancelacion-y-reembolso" element={<PoliciesPage />} />
                        <Route path="/encuesta-de-satisfaccion" element={<SurveyPage />} />
                        <Route path="/admin" element={<AdminPage />} />
                    </Routes>
                </main>
                <Footer />
                <WhatsAppButton />
            </div>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
